import React from "react";
import { Container } from "react-bootstrap";
import Row from 'react-bootstrap/Row';
import styles from '../../styles/pstlandingpage.module.scss'
import Card from "react-bootstrap/Card";
import CustomImage from "../CustomImage"; 
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
interface Props {
    data: any;
    bgcolor: any;
}
const ThreeSteps: React.FC<Props> = ({ data, bgcolor }) => {

    const settings = {
        dotsClass: styles.sliderDots,
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        autoplay: true,
        speed: 500,
        infinite: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    infinite: true,
                    dots: true,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                }
            }
        ]
    };
    return (
        <div className={styles.steps} style={{ backgroundColor: bgcolor || "#ffff" }}>
            <Container>
                <Row className="text-center">
                    <div className="mb-5">
                        <h2>{data?.sectionTitle}</h2>
                    </div>
                </Row>
                <div className="mb-4">
                    <Slider {...settings}>
                        {
                            data?.attendCard?.length > 0 &&
                            data?.attendCard?.map((points: any) => {
                                return (
                                    <div className={styles.points} >
                                        <Card className={styles.mainbox}>
                                            <Card.Body>
                                                <div className={styles.boximg}>
                                                    <CustomImage src={points?.cardImageUrl || "/images/testprep/1.png"} height={167} width={167} alt={"testprep"} />
                                                </div>
                                                <div className={styles.content}>
                                                    <span>{points?.otherTitle}</span>
                                                    <h6>{points?.cardTitle}</h6>
                                                    <p>{points?.cardDetail}</p>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </div>
            </Container>
        </div>
    )
}
export default ThreeSteps;